export default __webpack_public_path__ + "static/media/paper.543a11b4.png";